module.exports = __webpack_public_path__ + "static/img/san2.4d94fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/san2.png
// module id = 3gRt
// module chunks = 1